export const CONTACTS_NEW = {
  nameSingular: 'New Contact',
  namePlural: 'New Contacts',
  type: 'contacts_new',
  order: 0,
  visible: true,
  most_recent: [],
};

const INBOUND_TEXTS = {
  nameSingular: 'Inbound Text',
  namePlural: 'Inbound Texts',
  type: 'Text Received',
  order: 1,
  visible: true,
  most_recent: [],
};

const OPENED_EMAILS = {
  nameSingular: 'Opened Email',
  namePlural: 'Opened Emails',
  type: 'Email Opened',
  order: 2,
  visible: true,
  most_recent: [],
};

const CLICKED_EMAILS = {
  nameSingular: 'Clicked Email',
  namePlural: 'Clicked Emails',
  type: 'Email Clicked',
  order: 3,
  visible: true,
  most_recent: [],
};

const FAVORITE_PROPERTY_ADDED = {
  nameSingular: 'Favorite Property Added',
  namePlural: 'Favorite Properties Added',
  type: 'favorite_property_added',
  order: 4,
  visible: true,
  most_recent: [],
};

const PROPERTY_VIEWED = {
  nameSingular: 'Property Viewed',
  namePlural: 'Properties Viewed',
  type: 'property_viewed',
  order: 5,
  visible: true,
  most_recent: [],
};

const SAVED_SEARCH_ADDED = {
  nameSingular: 'Saved Search Added',
  namePlural: 'Saved Searches Added',
  type: 'saved_search_added',
  order: 6,
  visible: true,
  most_recent: [],
};

const SAVED_SEARCH_REMOVED = {
  nameSingular: 'Saved Search Removed',
  namePlural: 'Saved Searches Removed',
  type: 'saved_search_removed',
  order: 7,
  visible: false,
  most_recent: [],
};

const OUTBOUND_CALLS = {
  nameSingular: 'Outbound Call',
  namePlural: 'Outbound Calls',
  type: 'Outbound Click to Call',
  order: 8,
  visible: false,
  most_recent: [],
};

const OUTBOUND_TEXTS = {
  nameSingular: 'Outbound Text',
  namePlural: 'Outbound Texts',
  type: 'Text Sent',
  order: 9,
  visible: false,
  most_recent: [],
};

const OUTBOUND_EMAILS = {
  nameSingular: 'Outbound Email',
  namePlural: 'Outbound Emails',
  type: 'Email Sent',
  order: 10,
  visible: false,
  most_recent: [],
};

const USER_LOGIN = {
  nameSingular: 'User Login',
  namePlural: 'User Logins',
  type: 'user_login',
  order: 11,
  visible: false,
  most_recent: [],
};

const CREATED_A_FOLLOWUP = {
  nameSingular: 'Created a Follow-up',
  namePlural: 'Created Follow-ups',
  type: 'created_a_followup_for',
  order: 12,
  visible: false,
  most_recent: [],
};

const VALUATION_INQUIRY = {
  nameSingular: 'Valuation Inquiry',
  namePlural: 'Valuation Inquiries',
  type: 'valuation_inquery',
  order: 13,
  visible: false,
  most_recent: [],
};

const VISIT = {
  nameSingular: 'Visit',
  namePlural: 'Visits',
  type: 'visit',
  order: 14,
  visible: false,
  most_recent: [],
};

const EMAIL_BOUNCED = {
  nameSingular: 'Email Bounced',
  namePlural: 'Emails Bounced',
  type: 'email_bounced',
  aliases: ['Bounced Email'],
  order: 15,
  visible: false,
  most_recent: [],
};

const EMAIL_SPAM_COMPLAINT = {
  nameSingular: 'Spam Email Complaint',
  namePlural: 'Spam Email Complaints',
  type: 'email_spam_complaint',
  order: 16,
  visible: false,
  most_recent: [],
};

const FAVORITE_PROPERTY_SAVED = {
  nameSingular: 'Favorite Property Saved',
  namePlural: 'Favorite Properties Saved',
  type: 'favorite_property_saved',
  order: 17,
  visible: false,
  most_recent: [],
};

const MADE_AN_OFFER = {
  nameSingular: 'Offer Made',
  namePlural: 'Offers Made',
  type: 'made_an_offer',
  order: 18,
  visible: false,
  most_recent: [],
};

const SHOWING_REQUEST = {
  nameSingular: 'Showing Request',
  namePlural: 'Showing Requests',
  type: 'showing_request',
  order: 19,
  visible: false,
  most_recent: [],
};

// TODO MW - Add email rep
// export const EMAIL_REP = {
//   name: 'Email Reputation',
//   value: 100,
//   order: 8,
//   suffix: '%',
//   visible: true,
// };

export const ALL_VITALS = [
  CONTACTS_NEW,
  OUTBOUND_CALLS,
  OUTBOUND_TEXTS,
  INBOUND_TEXTS,
  OUTBOUND_EMAILS,
  OPENED_EMAILS,
  CLICKED_EMAILS,
  CREATED_A_FOLLOWUP,
  FAVORITE_PROPERTY_ADDED,
  PROPERTY_VIEWED,
  SAVED_SEARCH_ADDED,
  SAVED_SEARCH_REMOVED,
  USER_LOGIN,
  VALUATION_INQUIRY,
  VISIT,
  EMAIL_BOUNCED,
  EMAIL_SPAM_COMPLAINT,
  FAVORITE_PROPERTY_SAVED,
  MADE_AN_OFFER,
  SHOWING_REQUEST,
];
